// Angular
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'kt-edit-point-dialog',
	templateUrl: './edit-point-dialog.component.html'
})
export class EditPointDialogComponent implements OnInit {
	// Public properties
	viewLoading: boolean = false;
	pointVal = '';

	/**
	 * Component constructor
	 *
	 * @param dialogRef: MatDialogRef<EditPointDialogComponent>
	 * @param data: any
	 */
	constructor(
		public dialogRef: MatDialogRef<EditPointDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		this.pointVal = this.data.point;
	}

	/**
	 * Close dialog with false result
	 */
	onNoClick(): void {
		this.dialogRef.close();
	}

	/**
	 * Close dialog with true result
	 */
	onSaveClick(): void {
		/* Server loading imitation. Remove this */
		this.viewLoading = true;
		setTimeout(() => {
			this.dialogRef.close(this.pointVal); // Keep only this row
		}, 500);
	}
}
